module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.b2bcaa5.ttf";